import _ from 'lodash'
import axios from 'axios'

export default {
  namespaced: true,
  state: {
    artists: null
  },
  actions: {
    async fetch({state, commit}) {
      const { data } = await axios.get(`${process.env.KIRBY_ENDPOINT}/api/artists.php`)
      commit('receiveArtists', data)
    },
  },
  mutations: {
    receiveArtists(state, artists) {
      state.artists = artists
    },
  },
  getters: {
    artists(state, getters, rootState, rootGetters) {
      return _.map(state.artists, (artist, n) => {
        artist.current = n === getters.currentArtistIndex
        artist.hidden = n > getters.currentArtistIndex + 1
        artist.num = parseInt(artist.num)
        return artist
      })
    },
    currentArtist(state, getters, rootState, rootGetters) {
      return _.get(getters.artists, getters.currentArtistIndex)
    },
    currentArtistIndex(state, getters, rootState, rootGetters) {
      return _.findIndex(state.artists, { slug: rootGetters['site/currentArtist'] })
    },
    previousArtist(state, getters) {
      if(getters.currentArtist) return _.get(getters.artists, getters.currentArtistIndex - 1)
    },
    upcomingArtist(state, getters) {
      if(getters.currentArtist) return _.get(getters.artists, getters.currentArtistIndex + 1)
    }
  }
}


// WEBPACK FOOTER //
// ./src/store/artists.js